import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";
import { auth, db } from "../config"; // db = Firestore instance
import { doc, getDoc } from "firebase/firestore"; // Firestore modular functions
import { useNavigate } from "react-router-dom";

import { collection, query, where, getDocs } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";


import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip
);

const ranges = {
  "1D": 1,
  "1W": 7,
  "1M": 30,
  "3M": 90,
  "6M": 180,
  "1Y": 365,
};

function Dashboard() {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  ///////CHART
  const [active, setActive] = useState("1D");
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    axios
      .get("https://api.coingecko.com/api/v3/coins/bitcoin/market_chart", {
        params: {
          vs_currency: "usd",
          days: ranges[active],
        },
      })
      .then((res) => {
        setChartData({
          labels: res.data.prices.map((p) =>
            new Date(p[0]).toLocaleDateString()
          ),
          datasets: [
            {
              label: "BTC Price (USD)",
              data: res.data.prices.map((p) => p[1]),
              borderWidth: 2,
              pointRadius: 0,
              tension: 0.4,
            },
          ],
        });
      });
  }, [active]);
  ///////CHART

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const userRef = doc(db, "users", user.uid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            setUserData(userSnap.data());
          } else {
            console.log("No such user document!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        console.log("No user logged in");
        window.location.href = "/"; // Or: navigate("/") if using react-router
      }
    });

    return () => unsubscribe();
  }, []);

  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvestments = async (userId) => {
      try {
        const q = query(
          collection(db, "investments"),
          where("userId", "==", userId)
        );
        const querySnapshot = await getDocs(q);
        const fetched = querySnapshot.docs.map((doc) => doc.data());
        setInvestments(fetched);
      } catch (error) {
        console.error("Error fetching investments:", error);
      } finally {
        setLoading(false);
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchInvestments(user.uid);
      } else {
        setLoading(false);
        console.warn("No user is logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  const accountBalance = userData?.balance || 0.0;
  const activeInvestment = userData?.totalearnings || 0.0;
  const totalProfit = userData?.totalprofit || 0.0;
  const withdrawals = userData?.Totalwithdrawal || 0.0;

  return (
    <div>
      <Helmet>
        <script src="forthfunded/popper.min.js" />
        <script src="forthfunded/bootstrap.bundle.min.js" />
        <script src="forthfunded/defaultmenu.min.js" />
        <script src="forthfunded/waves.min.js" />
        <script src="forthfunded/sticky.js" />
        <script src="forthfunded/simplebar.min.js" />
        <script src="forthfunded/simplebar.js" />
        <script src="forthfunded/pickr.es5.min.js" />
        <script src="forthfunded/apexcharts.min.js" />
        <script src="forthfunded/crypto-dashboard.js" />
        <script src="forthfunded/custom-switcher.min.js" />
        <script src="forthfunded/custom.js" />
      </Helmet>

      <div className="page">
        <Header />
        <Nav />

        <div className="main-content app-content">
          <div className="container-fluid">
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <h1 className="page-title fw-semibold fs-18 mb-0">
                Welcome {userData?.fullname || ""}
              </h1>
              <div className="ms-md-1 ms-0">
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">Dashboards</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Home
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            <div className="row">
              {[
                { title: "Account Balance", value: accountBalance },
                { title: "Total Earnings", value: activeInvestment },
                { title: "Total Profit", value: totalProfit },
                { title: "Withdrawals", value: withdrawals },
              ].map((item, index) => (
                <div className="col-xxl-3 col-xl-6 col-lg-12" key={index}>
                  <div className="card custom-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center mb-4">
                        <div className="d-flex align-items-center">
                          <div className="me-2">
                            <span className="avatar avatar-md avatar-rounded bg-light p-2">
                              <img
                                src="../assets/images/crypto-currencies/regular/stellar.svg"
                                alt=""
                              />
                            </span>
                          </div>
                          <div className="mb-0 fw-semibold">{item.title}</div>
                        </div>
                        <div className="ms-auto" />
                      </div>
                      <div className="d-flex align-items-end">
                        <div>
                          <p className="mb-1">EUROS</p>
                          <p className="fs-20 mb-0 fw-semibold lh-1 text-primary">
                            €{parseFloat(item.value).toFixed(2)}
                          </p>
                        </div>
                        <div className="ms-auto text-end">
                          <p className="mb-0">Updated</p>
                          <p className="mb-0 text-muted">
                            <span className="text-success">now</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="col-xxl-12 col-xl-12">
                <div className="card custom-card">
                  <div className="card-header justify-content-between flex-wrap">
                    <div className="card-title">Market Statistics</div>

                    <div className="btn-group" role="group">
                      {Object.keys(ranges).map((label) => (
                        <button
                          key={label}
                          type="button"
                          onClick={() => setActive(label)}
                          className={`btn btn-${
                            active === label ? "primary" : "primary-light"
                          } btn-sm btn-wave`}
                        >
                          {label}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="card-body">
                    {chartData ? (
                      <Line data={chartData} />
                    ) : (
                      <div style={{ height: 300 }} />
                    )}
                  </div>
                </div>
              </div>

              {/* <div className="col-xxl-12 col-xl-12">
                <div className="card custom-card">
                  <div className="card-header justify-content-between flex-wrap">
                    <div className="card-title">Market Statistics</div>
                    <div className="btn-group" role="group">
                      {["1D", "1W", "1M", "3M", "6M", "1Y"].map((label) => (
                        <button
                          key={label}
                          type="button"
                          className={`btn btn-${
                            label === "1D" ? "primary" : "primary-light"
                          } btn-sm btn-wave`}
                        >
                          {label}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div
                      className="tradingview-widget-container"
                      style={{ height: "100%", width: "100%" }}
                    >
                      <div
                        id="tradingview_5981e"
                        style={{ height: "300px", width: "100%" }}
                      >
                        <div
                          id="tradingview_bf391-wrapper"
                          style={{
                            position: "relative",
                            boxSizing: "content-box",
                            fontFamily:
                              '-apple-system, BlinkMacSystemFont, "Trebuchet MS", Roboto, Ubuntu, sans-serif',
                            margin: "0px auto !important",
                            padding: "0px !important",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <iframe
                            title="advanced chart TradingView widget"
                            lang="en"
                            id="tradingview_bf391"
                            frameBorder={0}
                            allowTransparency="true"
                            scrolling="no"
                            allowFullScreen="true"
                            src="https://s.tradingview.com/widgetembed/?hideideas=1&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en#%7B%22symbol%22%3A%22BINANCE%3ABTCEUROST%22%2C%22frameElementId%22%3A%22tradingview_bf391%22%2C%22interval%22%3A%22D%22%2C%22hide_top_toolbar%22%3A%221%22%2C%22hide_legend%22%3A%221%22%2C%22allow_symbol_change%22%3A%221%22%2C%22save_image%22%3A%221%22%2C%22studies%22%3A%22%5B%5D%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22studies_overrides%22%3A%22%7B%7D%22%2C%22utm_source%22%3A%22forthfunded.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22chart%22%2C%22utm_term%22%3A%22BINANCE%3ABTCEUROST%22%2C%22page-uri%22%3A%22forthfunded.com%2Faccount%2F%22%7D"
                            style={{
                              width: "100%",
                              height: "100%",
                              margin: "0px !important",
                              padding: "0px !important",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* End of rows */}
            </div>

            {/* Start:: row-3 */}
            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div className="table-responsive">
                      {loading ? (
                        <p>Loading investments...</p>
                      ) : investments.length === 0 ? (
                        <p>No investments found.</p>
                      ) : (
                        <table className="table table-bordered text-nowrap w-100">
                          <thead>
                            <tr>
                              <th>Plan</th>
                              <th>Amount</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {investments.map((inv, idx) => (
                              <tr key={idx}>
                                <td>{inv.plan}</td>
                                <td>€{inv.amount.toLocaleString()}</td>
                                <td>
                                  <span
                                    className={`badge bg-${
                                      inv.status === "Active"
                                        ? "success"
                                        : "secondary"
                                    }`}
                                  >
                                    {inv.status}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End:: row-3 */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
